import { Cell, Grid, HFlow, Icon } from 'bold-ui'
import {
  CheckboxField,
  createDecorator,
  Form,
  FormDebouncedValueSpy,
  FormRenderProps,
  TextField,
} from 'components/form'
import { PopperButton, PopperControls } from 'components/popper'
import { FormState } from 'final-form'
import { useMemo } from 'react'

import { AgendamentosCidadaoFilterModel, metaAgendamentoCidadaoFilter } from '../model-cidadao'
import { AgendamentosCidadaoFilterPopper } from './AgendamentosCidadaoFilterPopper'
import { calculatorFiltroAgenda } from './calculator'

interface AgendamentosCidadaoFilterProps {
  today: Date
  filter: AgendamentosCidadaoFilterModel
  updateFilter(values: AgendamentosCidadaoFilterModel): void
}

export function AgendamentosCidadaoFilter(props: AgendamentosCidadaoFilterProps) {
  const { filter, today, updateFilter } = props

  const todayEpoch = Number(today)
  const decorator = useMemo(() => [createDecorator(...calculatorFiltroAgenda(new Date(todayEpoch)))], [todayEpoch])

  const handleTextFieldChange = ({ values }: FormState<AgendamentosCidadaoFilterModel>) => {
    updateFilter({ ...values, periodo: filter.periodo })
  }

  const renderForm = ({ handleSubmit }: FormRenderProps<AgendamentosCidadaoFilterModel>) => {
    const renderPopper = (ctrl: PopperControls) => (
      <AgendamentosCidadaoFilterPopper onSubmit={handleSubmit} filter={filter} {...ctrl} />
    )
    return (
      <>
        <Grid alignItems='flex-start'>
          <Cell size={4}>
            <FormDebouncedValueSpy onChange={handleTextFieldChange} />
            <TextField
              name={metaAgendamentoCidadaoFilter.nomeProfissional}
              placeholder='Pesquise por profissional'
              icon='zoomOutline'
            />
          </Cell>
          <Cell>
            <CheckboxField
              name={metaAgendamentoCidadaoFilter.isAgendamentosAnteriores}
              label='Ver agendamentos anteriores'
              onChange={handleSubmit}
            />
          </Cell>
          <Cell>
            <CheckboxField
              name={metaAgendamentoCidadaoFilter.isSomenteMeus}
              label='Ver somente meus agendamentos'
              onChange={handleSubmit}
            />
          </Cell>
        </Grid>
        <PopperButton kind='primary' placement='bottom-end' size='small' renderPopper={renderPopper}>
          <Icon icon='filterOutline' />
          Filtro
        </PopperButton>
      </>
    )
  }
  return (
    <HFlow alignItems='center' justifyContent='space-between' style={{ gridTemplateColumns: '1fr' }}>
      <Form<AgendamentosCidadaoFilterModel> render={renderForm} decorators={decorator} onSubmit={updateFilter} />
    </HFlow>
  )
}
